import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Checkbox } from '../ui/checkbox';
import { FormField, SchedulerOptions } from '../../types/form';

interface SchedulerFieldEditorProps {
  editedField: FormField;
  onFieldChange: (updates: Partial<FormField>) => void;
}

export const SchedulerFieldEditor: React.FC<SchedulerFieldEditorProps> = ({
  editedField,
  onFieldChange,
}) => {
  const options = (editedField.options || {}) as SchedulerOptions;

  return (
    <div>
      <Label htmlFor={`calLink-${editedField.id}`}>Cal.com booking URL</Label>
      <Input
        id={`calLink-${editedField.id}`}
        type="text"
        value={options.calLink || ''}
        onChange={(e) =>
          onFieldChange({
            options: { ...editedField.options, calLink: e.target.value },
          })
        }
        placeholder="https://cal.com/your-name/intro-call"
      />
      <p className="mt-1 text-xs text-muted-foreground">
        Paste the full Cal.com booking link (or a username/event-type slug) to embed the scheduler.
      </p>

      <div className="mt-4 flex items-start gap-2">
        <Checkbox
          id={`submitOnBooking-${editedField.id}`}
          checked={!!options.submitOnBooking}
          onCheckedChange={(checked) =>
            onFieldChange({
              options: { ...editedField.options, submitOnBooking: checked === true },
            })
          }
          className="mt-0.5"
        />
        <div>
          <Label htmlFor={`submitOnBooking-${editedField.id}`} className="cursor-pointer">
            Submit on booking
          </Label>
          <p className="mt-1 text-xs text-muted-foreground">
            Hide the form's submit button and submit automatically as soon as the
            respondent books their meeting.
          </p>
        </div>
      </div>
    </div>
  );
};
